import { mapActions } from 'vuex';

import { activeNamespaces } from '@/store';

export default {
    beforeDestroy() {
        this.resetState();
    },
    methods: {
        ...mapActions(activeNamespaces.savedFilters, {
            resetState: 'RESET_STATE',
        }),
    },
};
